import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { Grid, Skeleton, Typography } from "@mui/material";
import { DivRootStyled, SearchInputStyled } from "./CredentialsToolbar.styles";
import { TranslationKeys } from "app/translations";
const CredentialsToolbar = (props) => {
  const { className, handleSearch, intl, totalCount } = props;
  return /* @__PURE__ */ React.createElement(DivRootStyled, { className }, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 3 }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: TranslationKeys.menu_credentials })), /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle2", textTransform: "uppercase" }, typeof totalCount !== "undefined" ? /* @__PURE__ */ React.createElement(FormattedMessage, { id: TranslationKeys.credentials_totalCount, values: { totalCount } }) : /* @__PURE__ */ React.createElement(Skeleton, { width: 200 }))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(
    SearchInputStyled,
    {
      onChange: handleSearch,
      placeholder: intl.formatMessage({ id: TranslationKeys.credentials_search }).toUpperCase()
    }
  ))));
};
CredentialsToolbar.propTypes = {
  className: PropTypes.string,
  handleClickAdd: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  totalCount: PropTypes.number
};
export default injectIntl(CredentialsToolbar);
